const HOTJAR_HOSTNAME = 'talent.rocken.ch'
const HOTJAR_ID = 4996685
const HOTJAR_SV = 6

export function loadHotjar() {
  if (location.hostname !== HOTJAR_HOSTNAME) return
  if (window.hj) return

  ;(function(h, o, t, j, a, r) {
    h.hj = h.hj || function() {
      (h.hj.q = h.hj.q || []).push(arguments)
    }
    h._hjSettings = { hjid: HOTJAR_ID, hjsv: HOTJAR_SV }
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
    a.appendChild(r)
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
}
